<template>
  <div class="product-page">
    <section class="hero">
      <h1 class="hero-title">精选好物</h1>
      <p class="hero-sub">选择心仪的产品，安全快捷支付</p>
    </section>

    <div class="product-list" v-if="products.length">
      <div class="product-card" v-for="product in products" :key="product.id" @click="goDetail(product)">
        <div class="product-img">
          <img v-if="product.image" :src="product.image" :alt="product.title" loading="lazy" />
          <div v-else class="img-placeholder">暂无图片</div>
        </div>
        <div class="product-info">
          <h3 class="product-title">{{ product.title }}</h3>
          <p class="product-desc">{{ product.description || '暂无描述' }}</p>
          <div class="product-bottom">
            <span class="price">
              <em>¥</em>{{ product.price }}
            </span>
            <button class="buy-btn" @click.stop="buy(product)">立即购买</button>
          </div>
        </div>
      </div>
    </div>

    <div class="empty" v-else-if="loading">
      <div class="spinner"></div>
      <p>加载中...</p>
    </div>
    <div class="empty" v-else>
      <p>暂无产品</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import request from '@/api/index'

const router = useRouter()
const products = ref([])
const loading = ref(true)

// 进入产品详情页
function goDetail(product) {
  router.push(`/product/${product.id}`)
}

// 获取产品列表
async function fetchProducts() {
  try {
    const res = await request.get('/index/products/')
    if (res.code === 100) {
      products.value = res.data || []
    }
  } catch (e) {
    console.error('获取产品列表失败', e)
  } finally {
    loading.value = false
  }
}

// 下单并跳转支付宝支付
async function buy(product) {
  try {
    const res = await request.post('/index/order/', { product_id: product.id })
    if (res.code === 100) {
      window.location.href = res.data.pay_url
    } else {
      alert(res.msg)
    }
  } catch (e) {
    console.error('下单失败', e)
    alert('下单失败，请稍后重试')
  }
}

onMounted(fetchProducts)
</script>

<style scoped>
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 24px 60px;
}

/* Hero 区 */
.hero {
  text-align: center;
  padding: 24px 0 48px;
}

.hero-title {
  font-size: 36px;
  font-weight: 800;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #4f7cff 0%, #7b5bff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  margin-bottom: 12px;
}

.hero-sub {
  color: var(--text-light);
  font-size: 15px;
}

/* 产品网格 */
.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 28px;
}

.product-card {
  background: var(--card-bg);
  border-radius: var(--radius);
  overflow: hidden;
  cursor: pointer;
  box-shadow: var(--shadow);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.product-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-hover);
}

.product-img {
  position: relative;
  height: 220px;
  background: #eef0f6;
  overflow: hidden;
}

/* 容器固定，图片在容器内完整显示（contain 不裁剪，四周留白） */
.product-img img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.img-placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-light);
  font-size: 14px;
}

.product-info {
  padding: 18px 20px 20px;
}

.product-title {
  font-size: 17px;
  font-weight: 600;
  color: var(--text-main);
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-desc {
  font-size: 13px;
  color: var(--text-light);
  line-height: 1.5;
  height: 38px;
  overflow: hidden;
  margin-bottom: 16px;
}

.product-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price {
  font-size: 24px;
  font-weight: 800;
  color: var(--price);
}

.price em {
  font-style: normal;
  font-size: 14px;
  margin-right: 1px;
}

.buy-btn {
  padding: 9px 22px;
  border: none;
  border-radius: 22px;
  background: var(--gradient);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(79, 124, 255, 0.3);
  transition: all 0.2s ease;
}

.buy-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(79, 124, 255, 0.4);
}

.buy-btn:active {
  transform: translateY(0);
}

/* 空态/加载 */
.empty {
  text-align: center;
  color: var(--text-light);
  padding: 80px 0;
  font-size: 15px;
}

.spinner {
  width: 32px;
  height: 32px;
  margin: 0 auto 16px;
  border: 3px solid rgba(79, 124, 255, 0.15);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
